import React, { useState } from "react";
import Modal from "react-modal";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useHistory } from "react-router-dom";
import ENUMS from "../../utils/ENUMS";
import { deleteUserAccount } from "../../services/apiService";

Modal.setAppElement("#root");

const DeleteAccount = () => {
  const history = useHistory();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteAccount = () => {
    const token =
      localStorage.getItem("jwtToken") ||
      localStorage.getItem(ENUMS.AUTH) ||
      localStorage.getItem("token") ||
      "";

    if (!token) {
      toast.error("Authentication token not found. Please log in again.");
      return;
    }

    setIsDeleting(true);

    deleteUserAccount(token)
      .then((res) => {
        setIsDeleting(false);
        setModalIsOpen(false);
        toast.success("Account deleted successfully.");
        // Clear all session and cached local storage data
        localStorage.clear();
        setTimeout(() => {
          history.push("/club-login");
          window.location.reload();
        }, 1500);
      })
      .catch((err) => {
        setIsDeleting(false);
        console.error("Delete account error:", err);
        const errMsg =
          err?.response?.data?.message ||
          err?.response?.data?.detail ||
          err?.response?.data?.error ||
          "Failed to delete account. Please try again.";
        toast.error(errMsg);
      });
  };

  return (
    <>
      <section className="club_Login">
        <ToastContainer />
        <div className="page-width">
          <div className="acc-alert-data gap-block-section">
            <h1 className="text-jost-sb-50"></h1>
            <div className="acc-alert__accordion__wrap">
              <div className="acc-alert__accordion_head">
                <h1 className="text-jost-sb-24">Delete Account</h1>
                <p className="text-ops-rg-16-wt">
                  Permanently delete your Timely Golf account and all associated club data.
                </p>
              </div>

              <div className="acc-alert__accordion_content_wrap">
                <div className="delete-account__card">
                  <div className="delete-account__card__warning">
                    <h3>Warning: This action is permanent</h3>
                    <p>
                      Deleting your account will immediately and irreversibly remove:
                    </p>
                    <ul>
                      <li>Your club profile and user login credentials</li>
                      <li>All registered golf courses, hole layouts, and GPS coordinate mappings</li>
                      <li>Course alert configurations, pace-of-play rules, and incident records</li>
                      <li>Live view tracking data and member records</li>
                      <li>Any active subscriptions or billing arrangements with Timely Golf</li>
                    </ul>
                  </div>

                  <p className="text-ops-rg-16" style={{ color: "#333", margin: "1rem 0", lineHeight: "1.6" }}>
                    Once deleted, there is no way to recover your account or restore your data.
                    If you are sure you want to proceed with deleting your account, please click below.
                  </p>

                  <div className="delete-account__card__action">
                    <button
                      type="button"
                      className="res-btn-primary"
                      onClick={() => setModalIsOpen(true)}
                    >
                      Delete Account
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Confirmation Modal */}
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => !isDeleting && setModalIsOpen(false)}
          className="custom-modal"
          style={{
            overlay: {
              zIndex: 1000,
              backgroundColor: "rgba(0, 0, 0, 0.65)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
            content: {
              position: "relative",
              top: "auto",
              left: "auto",
              right: "auto",
              bottom: "auto",
              maxWidth: "540px",
              width: "90%",
              border: "1px solid #ddd",
              background: "#fff",
              borderRadius: "8px",
              outline: "none",
              padding: "35px 25px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              boxShadow: "0 10px 25px rgba(0, 0, 0, 0.25)",
            },
          }}
        >
          <button
            type="button"
            className="modal-content--cross"
            onClick={() => !isDeleting && setModalIsOpen(false)}
            disabled={isDeleting}
          >
            <img
              src={require("../../assets/images/cross/Group 6926.svg").default}
              alt="Close"
            />
          </button>
          <div
            className="modal-content"
            style={{ boxShadow: "none", border: "none", textAlign: "center" }}
          >
            <h1
              className="modal-content--title text-jost-sb-24"
              style={{ color: "#ee2737", marginBottom: "1rem" }}
            >
              Are you sure you want to delete your account?
            </h1>
            <p
              className="modal-content--para text-ops-rg-16"
              style={{ color: "#444", marginBottom: "2rem", lineHeight: "1.5" }}
            >
              This action cannot be undone. All club information, golf courses,
              configurations, and account data will be permanently removed.
            </p>
            <div className="modal-content--links">
              <button
                type="button"
                className="res-btn-primary"
                onClick={handleDeleteAccount}
                disabled={isDeleting}
              >
                {isDeleting ? "Deleting..." : "Yes, Delete Account"}
              </button>
              <button
                type="button"
                className="res-btn-ternary"
                onClick={() => setModalIsOpen(false)}
                disabled={isDeleting}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
      </section>
    </>
  );
};

export default DeleteAccount;
